<div class="time-picker-wrapper" *ngIf="timePickerSelection">
  <div class="item-list">
    <div class="mat-trigger-content">
      <div class="left-content">
        <div
          [ngClass]="{
            customdate: isCustom,
            timePickerPresent: !isCustom
          }"
        >
          <div class="time-picker-label">
            <div
              class="time-picker-selection-label"
              [ngClass]="{
                custom_text: isCustom,
                last1h: isLast1h,
                last_time_range_text: isLastTimeRange || isLast1h
              }"
            >
              {{ timePickerSelection.label }}<span>:</span>
            </div>
            <div
              *ngIf="isLast1h && !utc"
              class="refresh-icon"
              (click)="pageTriaged ? $event.stopPropagation() : toggleAutoRefresh()"
              [title]="getAutoRefreshTitle()"
              [ngClass]="{ disabled: pageTriaged }"
            >
              <img class="icon" *ngIf="autoRefreshEnabled" [src]="'images/auto-refresh.svg'" />
              <img
                class="icon"
                *ngIf="!autoRefreshEnabled"
                [src]="'images/auto-refresh-link.svg'"
              />
            </div>
          </div>
          <div class="time-picker-selection" (click)="toggleTimeRangeSelector()">
            <div
              class="time-picker-selection-value"
              [ngClass]="{
                last1h: isLast1h,
                custom_date: isCustom,
                last_time_range_date: isLastTimeRange || isLast1h
              }"
            >
              {{ label }}
            </div>
            <div class="dropdown_arrow">
              <mat-icon>arrow_drop_down</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showTimeRangeSelector" class="time-range-selector">
  <div
    *ngIf="gridsterTranslateValues"
    class="overlay"
    (click)="closeTimeRangeSelector()"
    [style.transform]="'translateX(-' + gridsterTranslateValues.x + 'px)'"
  ></div>

  <div class="content">
    <div class="range-calender" *ngIf="showCalendar">
      <div class="fixed-range-block">
        <div class="fixed-range__dates">
          <div>
            <div class="fixed-range__date">
              <div class="utc-left-label" *ngIf="utc">UTC</div>
              <div class="utc-right-label" *ngIf="utc">UTC</div>
              <nk-range-datetime-edit
                [showSeconds]="false"
                [(value)]="calendarModel"
                (valueChange)="onCustomRangeSelect($event)"
                (validStateChange)="onValidStateChange($event)"
                [min]="minDate"
                [max]="maxDate"
              >
                <div
                  *ngIf="showTimeRangeError || showTimeStateChangeError"
                  class="fixed-range__error"
                >
                  Not a valid time range
                </div>
                <div class="action-buttons">
                  <button mat-button mat-stroked-button (click)="closeTimeRangeSelector()">
                    CANCEL
                  </button>
                  <button
                    mat-button
                    mat-flat-button
                    color="primary"
                    (click)="applyRange()"
                    [disabled]="showTimeRangeError || showTimeStateChangeError"
                    [ngClass]="{
                      disableApplButton: showTimeRangeError || showTimeStateChangeError
                    }"
                  >
                    APPLY
                  </button>
                </div>
              </nk-range-datetime-edit>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="item-list">
      <div *ngFor="let item of timePickerOptions">
        <div
          class="itemList"
          [ngClass]="getItemCSSClass(item.timeRange)"
          (click)="chooseTimePickerOption(item)"
        >
          {{ item.label }}
        </div>
      </div>
      <div *ngIf="showCalendar && utc">
        <mat-form-field class="granularity-form-field">
          <mat-label>Granularity</mat-label>
          <mat-select [(ngModel)]="selectedGranularity">
            <ng-container *ngFor="let item of granularityPicklist">
              <mat-option *ngIf="item.active" [value]="item.value">{{ item.label }} </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
        <div class="custom-label">
          <div>{{ customStartTime }}</div>
          <div>{{ customEndTime }}</div>
          <div>{{ timeZone }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
